var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hideCategory)?_c('a-link',{staticClass:"category-label-link text-medium bold",attrs:{"to":_vm.linkToCategoryPage,"trailing-slash":!_vm.isMigratedCategory}},[_vm._v("\n  "+_vm._s(_vm.category.name)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }